/**
 * v1.14.70.0 — AI Site Doctor client sanitizer (browser).
 * Stessa logica del backend sanitizer.py — applicata PRIMA dell'invio.
 */

const SENSITIVE_KEYS = /(password|passwd|secret|token|auth|authorization|cookie|api[_-]?key|apikey|bearer|session|csrf|x-csrf)/i;

const PATTERNS = [
  [/Bearer\s+[A-Za-z0-9._\-]+/g, "Bearer [MASKED]"],
  [/eyJ[A-Za-z0-9._\-]{20,}/g, "[JWT_MASKED]"],
  [/\b[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]\b/g, "[CF_MASKED]"],
  [/\b[\w._%+-]+@[\w.-]+\.[A-Za-z]{2,}\b/g, "[EMAIL_MASKED]"],
  [/\b\d{4}[\s-]?\d{4}[\s-]?\d{4}[\s-]?\d{4}\b/g, "[CC_MASKED]"],
  [/(\+39)?[\s-]?3\d{2}[\s-]?\d{6,7}\b/g, "[TEL_MASKED]"],
];
const PIVA_CTX = /(p\.?\s?iva|partita\s*iva|p\.iva)[\s:=]*(\d{11})/gi;

function maskString(s) {
  if (typeof s !== "string") return s;
  let out = s.replace(PIVA_CTX, (m, p1) => `${p1} [PIVA_MASKED]`);
  for (const [rx, repl] of PATTERNS) out = out.replace(rx, repl);
  return out;
}

export function sanitizePayload(input) {
  if (input === null || input === undefined) return input;
  if (Array.isArray(input)) return input.map(sanitizePayload);
  if (typeof input === "object") {
    const out = {};
    for (const [k, v] of Object.entries(input)) {
      if (typeof k === "string" && SENSITIVE_KEYS.test(k)) {
        out[k] = "[MASKED]";
      } else {
        out[k] = sanitizePayload(v);
      }
    }
    return out;
  }
  if (typeof input === "string") return maskString(input);
  return input;
}
